import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const DAY_LABELS = { mon: 'Pazartesi', tue: 'Salı', wed: 'Çarşamba', thu: 'Perşembe', fri: 'Cuma', sat: 'Cumartesi', sun: 'Pazar' };

const DEFAULT_HOURS = {
  mon: { active: true, open: '09:00', close: '20:00' },
  tue: { active: true, open: '09:00', close: '20:00' },
  wed: { active: true, open: '09:00', close: '20:00' },
  thu: { active: true, open: '09:00', close: '20:00' },
  fri: { active: true, open: '09:00', close: '20:00' },
  sat: { active: true, open: '09:00', close: '18:00' },
  sun: { active: false, open: '00:00', close: '00:00' }
};

const TONES = [
  { value: 'warm', label: '🤗 Sıcak / Samimi' },
  { value: 'professional', label: '💼 Profesyonel' },
  { value: 'friendly', label: '😊 Arkadaşça' },
  { value: 'formal', label: '🎩 Resmi' }
];

function PublicOnboarding() {
  const { branchId, token } = useParams();
  const [branch, setBranch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [businessName, setBusinessName] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [hours, setHours] = useState(DEFAULT_HOURS);
  const [services, setServices] = useState([{ name: '', price: '', duration_min: '' }]);
  const [tone, setTone] = useState('warm');
  const [notes, setNotes] = useState('');
  const [canBookAppointments, setCanBookAppointments] = useState(true);
  const [canTakePreConsultation, setCanTakePreConsultation] = useState(true);
  const [canSharePrices, setCanSharePrices] = useState(true);
  const [canGiveHealthAdvice, setCanGiveHealthAdvice] = useState(false);

  useEffect(() => {
    axios.get(`/api/public/onboarding/${branchId}/${token}`)
      .then(res => { setBranch(res.data); setBusinessName(res.data.name || ''); })
      .catch(err => setError(err.response?.data?.error || 'Bağlantı geçersiz veya süresi dolmuş olabilir.'))
      .finally(() => setLoading(false));
  }, [branchId, token]);

  const handleHourChange = (day, field, value) => {
    setHours({ ...hours, [day]: { ...hours[day], [field]: value } });
  };

  const addServiceRow = () => setServices([...services, { name: '', price: '', duration_min: '' }]);
  const removeServiceRow = (i) => setServices(services.filter((_, idx) => idx !== i));
  const updateServiceRow = (i, field, value) => {
    const next = [...services];
    next[i] = { ...next[i], [field]: value };
    setServices(next);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`/api/public/onboarding/${branchId}/${token}`, {
        business_name: businessName,
        address,
        phone,
        working_hours: hours,
        services: services.filter(s => s.name.trim()).map(s => ({
          name: s.name, price: parseFloat(s.price) || 0, duration_min: parseInt(s.duration_min, 10) || 30
        })),
        tone,
        special_notes: notes,
        can_book_appointments: canBookAppointments,
        can_take_pre_consultation: canTakePreConsultation,
        can_share_prices: canSharePrices,
        can_give_health_advice: canGiveHealthAdvice
      });
      setSuccess(true);
    } catch (err) {
      alert(err.response?.data?.error || 'Gönderim sırasında bir hata oluştu.');
    } finally {
      setSubmitting(false);
    }
  };

  const cardStyle = { width: '100%', maxWidth: '640px', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 24px 64px rgba(0,0,0,0.6)', backdropFilter: 'blur(20px)' };
  const labelStyle = { fontSize: '12px', color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: '6px' };
  const sectionStyle = { marginBottom: '22px' };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#09090e' }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#09090e', padding: '20px' }}>
        <div style={{ background: 'rgba(244, 63, 94, 0.08)', border: '1px solid rgba(244, 63, 94, 0.2)', padding: '32px', borderRadius: '20px', maxWidth: '480px', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '8px' }}>Bağlantı Hatası</h2>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', lineHeight: '1.6' }}>{error}</p>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#09090e', padding: '20px' }}>
        <div style={{ background: 'rgba(16, 185, 129, 0.08)', border: '1px solid rgba(16, 185, 129, 0.2)', padding: '40px 32px', borderRadius: '24px', maxWidth: '480px', textAlign: 'center' }}>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>✅</div>
          <h2 style={{ color: '#fff', fontSize: '1.5rem', marginBottom: '12px', fontWeight: 800 }}>Teşekkürler!</h2>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', lineHeight: '1.6' }}>
            Bilgileriniz alındı. En kısa sürede işletmenize özel asistanınız hazırlanacak.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#09090e', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px' }}>
      <div style={cardStyle}>
        <div style={{ padding: '24px', background: 'linear-gradient(135deg, rgba(var(--primary-rgb), 0.1) 0%, rgba(var(--secondary-rgb), 0.1) 100%)', borderBottom: '1px solid rgba(255,255,255,0.05)', textAlign: 'center' }}>
          <h2 style={{ color: '#fff', fontSize: '1.25rem', fontWeight: 800, margin: 0 }}>İşletme Bilgi Formu</h2>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', marginTop: '4px', margin: 0 }}>
            {branch?.name ? `${branch.name} için` : ''} birkaç bilgi verin, WhatsApp asistanınız otomatik hazırlansın
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: '24px' }}>
          <div style={sectionStyle}>
            <label style={labelStyle}>İşletme Adı *</label>
            <input className="input" value={businessName} onChange={e => setBusinessName(e.target.value)} required />
          </div>
          <div style={sectionStyle}>
            <label style={labelStyle}>Adres</label>
            <input className="input" value={address} onChange={e => setAddress(e.target.value)} />
          </div>
          <div style={sectionStyle}>
            <label style={labelStyle}>Telefon</label>
            <input className="input" value={phone} onChange={e => setPhone(e.target.value)} placeholder="05XX XXX XX XX" />
          </div>

          <div style={sectionStyle}>
            <label style={labelStyle}>Çalışma Saatleri</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {Object.keys(DAY_LABELS).map(day => (
                <div key={day} style={{ display: 'grid', gridTemplateColumns: '90px auto 1fr 1fr', gap: '8px', alignItems: 'center' }}>
                  <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>{DAY_LABELS[day]}</span>
                  <input type="checkbox" checked={hours[day]?.active || false} onChange={e => handleHourChange(day, 'active', e.target.checked)} />
                  <input type="time" className="input" disabled={!hours[day]?.active} value={hours[day]?.open || '09:00'} onChange={e => handleHourChange(day, 'open', e.target.value)} />
                  <input type="time" className="input" disabled={!hours[day]?.active} value={hours[day]?.close || '20:00'} onChange={e => handleHourChange(day, 'close', e.target.value)} />
                </div>
              ))}
            </div>
          </div>

          <div style={sectionStyle}>
            <label style={labelStyle}>Hizmetler</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {services.map((s, i) => (
                <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 90px 90px 28px', gap: '8px' }}>
                  <input className="input" placeholder="Hizmet adı" value={s.name} onChange={e => updateServiceRow(i, 'name', e.target.value)} />
                  <input className="input" type="number" placeholder="Fiyat ₺" value={s.price} onChange={e => updateServiceRow(i, 'price', e.target.value)} />
                  <input className="input" type="number" placeholder="Dk" value={s.duration_min} onChange={e => updateServiceRow(i, 'duration_min', e.target.value)} />
                  <button type="button" onClick={() => removeServiceRow(i)} style={{ background: 'none', border: 'none', color: '#F87171', cursor: 'pointer', fontSize: '16px' }}>×</button>
                </div>
              ))}
            </div>
            <button type="button" onClick={addServiceRow} style={{ marginTop: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '8px', color: '#E5E7EB', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' }}>
              + Hizmet Ekle
            </button>
          </div>

          <div style={sectionStyle}>
            <label style={labelStyle}>Asistanınız Neler Yapabilsin?</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                { label: 'Randevu alabilsin', desc: 'Kapalıysa müşteriyi telefonla aramaya yönlendirir', value: canBookAppointments, set: setCanBookAppointments },
                { label: 'Ön görüşme / bilgi talebi alabilsin', desc: 'İlk temas kurup talebi kayda alır', value: canTakePreConsultation, set: setCanTakePreConsultation },
                { label: 'Fiyat bilgisi paylaşabilsin', desc: 'Kapalıysa müşteriyi aramaya yönlendirir', value: canSharePrices, set: setCanSharePrices },
                { label: 'Sağlık/bakım tavsiyesi verebilsin', desc: 'Genel bilgi düzeyinde — klinik/sağlık işletmeleri için', value: canGiveHealthAdvice, set: setCanGiveHealthAdvice }
              ].map((item, i) => (
                <div key={i} onClick={() => item.set(!item.value)} style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer',
                  background: item.value ? 'rgba(0, 242, 254, 0.06)' : 'rgba(255,255,255,0.01)',
                  border: item.value ? '1px solid rgba(0, 242, 254, 0.25)' : '1px solid rgba(255,255,255,0.06)',
                  borderRadius: '12px', padding: '12px 14px'
                }}>
                  <div>
                    <div style={{ color: '#fff', fontSize: '13px', fontWeight: 600 }}>{item.label}</div>
                    <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px', marginTop: '2px' }}>{item.desc}</div>
                  </div>
                  <div style={{
                    width: '40px', height: '22px', borderRadius: '20px', flexShrink: 0, position: 'relative',
                    background: item.value ? 'var(--primary)' : 'rgba(255,255,255,0.15)', transition: 'all 0.2s'
                  }}>
                    <div style={{
                      width: '16px', height: '16px', borderRadius: '50%', background: '#fff', position: 'absolute',
                      top: '3px', left: item.value ? '21px' : '3px', transition: 'all 0.2s'
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={sectionStyle}>
            <label style={labelStyle}>Konuşma Tonu</label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              {TONES.map(t => (
                <div
                  key={t.value}
                  onClick={() => setTone(t.value)}
                  style={{
                    background: tone === t.value ? 'rgba(0, 242, 254, 0.08)' : 'rgba(255,255,255,0.01)',
                    border: tone === t.value ? '1px solid var(--primary)' : '1px solid rgba(255,255,255,0.06)',
                    borderRadius: '12px', padding: '10px', textAlign: 'center', cursor: 'pointer', fontWeight: 600, color: '#fff', fontSize: '13px'
                  }}
                >
                  {t.label}
                </div>
              ))}
            </div>
          </div>

          <div style={sectionStyle}>
            <label style={labelStyle}>Özel Notlar (opsiyonel)</label>
            <textarea className="textarea" rows={3} value={notes} onChange={e => setNotes(e.target.value)}
              placeholder="Örn: Randevu iptalinde 24 saat önce haber verilmeli, öğrenci indirimi yok..." />
          </div>

          <button type="submit" className="btn btn-primary" disabled={submitting} style={{ width: '100%', padding: '14px', borderRadius: '12px', fontWeight: 700 }}>
            {submitting ? '⌛ Gönderiliyor...' : '📤 Gönder'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default PublicOnboarding;
